import { render } from "./GoalManagement.vue?vue&type=template&id=7c3461d3&scoped=true"
import script from "./GoalManagement.vue?vue&type=script&lang=js"
export * from "./GoalManagement.vue?vue&type=script&lang=js"

import "./GoalManagement.vue?vue&type=style&index=0&id=7c3461d3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c3461d3"]])

export default __exports__